import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography as T } from '@dev/ee-components';

import { getEmailsStore } from '@/store/emails/actions';

const EmailWraperContainer = styled.div`
    margin-top: 64px;
    padding: 24px 0;
`;

const EmailWraper = (): JSX.Element => {
    const { t } = useTranslation();

    const { email } = useSelector(getEmailsStore);

    return (
        <EmailWraperContainer>
            <T variant="h1">{t('email')}</T>
            <iframe title={email?.Preview?.Subject || ''} srcDoc={email?.Preview?.Body} />
        </EmailWraperContainer>
    );
};

export default EmailWraper;
